'use strict';

var $ = require('jquery');

const className = 'SearchDoublePlaceholder-hidetext';

function embeddedSearchClick(e) {
  let $e = $(e.target),
      $parent = $e.parent();
  if($e.val() !== '') {
    $parent.addClass(className);
  } else {
    $parent.removeClass(className);
  }
}

export function create($parent) {
  var $embeddedSearch = $parent.find('.EmbeddedSearch');
  if($embeddedSearch.length) {
    $embeddedSearch.on('input', 'blur', embeddedSearchClick);
  }
}



// WEBPACK FOOTER //
// ./uikit/components/EmbeddedSearch/EmbeddedSearch.js